import { useContext } from 'react'
import { SanityImageFragment } from '@data/sanity/queries/types/image'
import { StringsContext } from '@lib/strings'
import Photo from '@components/photo'
import BaseInternalLink from '@components/link/base-internal-link'

interface MobileLogoProps {
  invertedLogo?: SanityImageFragment
}

const MobileLogo = ({ invertedLogo }: MobileLogoProps) => {
  const strings = useContext(StringsContext)

  return (
    <div className="relative h-[60px] w-[60px] md:h-[100px] md:w-[100px]">
      {!!invertedLogo?.asset && (
        <BaseInternalLink href="/" aria-label={strings.goHomeLabel}>
          <Photo
            image={invertedLogo}
            width={invertedLogo.dimensions.width}
            height={invertedLogo.dimensions.height}
            priority
            showPlaceholder={false}
            imageClassName="block absolute top-0 right-0 bottom-0 left-0 m-auto min-w-[100%] max-w-[100%] min-h-[100%] max-h-[100%] w-0 h-0 overflow-hidden"
          />
        </BaseInternalLink>
      )}
    </div>
  )
}

export default MobileLogo
